import type { ExternalTableSchema } from '@packages/table-builder';

export const participantBroadcastTable: ExternalTableSchema = {
  metadata: {
    title: 'Participant Broadcast',
    entity: 'ParticipantBroadcast',
    description: 'Broadcast messages shown to participants.',
  },

  dataSource: {
    endpoint:
      '/api/customer/api/app/participant-broadcast-message/participant-broadcast-message-list',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      Filter: 'table.searchText',
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
  },

  columns: [
    {
      field: 'title',
      header: 'Title',
      type: 'text',
      sortable: false,
      width: 200,
    },
    {
      field: 'message',
      header: 'Message',
      type: 'text',
      sortable: false,
      width: 200,
    },
    {
      field: 'startDate',
      header: 'Time Duration',
      type: 'custom',
      sortable: false,
      width: 200,
      fields: { start: 'startDate', end: 'endDate' },
      renderer: 'participantBroadcastTimeDuration',
    },
  ],

  actions: {
    row: [
      { id: 'VIEW_PARTICIPANT_BROADCAST', label: 'View' },
      { id: 'EDIT_PARTICIPANT_BROADCAST', label: 'Edit' },
      { id: 'DELETE_PARTICIPANT_BROADCAST', label: 'Delete', variant: 'danger' },
    ],
    toolbar: {
      primary: {
        id: 'CREATE_PARTICIPANT_BROADCAST',
        label: 'Create Message',
        icon: 'add_circle_outline',
      },
    },
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    columnPreferences: { persistenceKey: 'Ppt Broadcast', resizable: true, reorderable: true },
  },
};
